import { createUseStyles } from 'react-jss'

import { zIndex1 } from '../../../../../../styles/const/common'

const useStyles = createUseStyles(theme => ({
  storyItemMedia: {
    zIndex: zIndex1,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',

    '& svg path': {
      fill: 'white'
    },
    '& video': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  },
  storyImage: {
    width: 'auto',
    maxWidth: ['unset', '!important'],
    height: '100%'
  },
  storyVideoPicture: {
    width: ['100%', '!important']
  }
}))

export default useStyles
